import {Component, EventEmitter, OnInit, Output, Input} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {CommonMissionService} from '../../../services/common-mission.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {AdminValetService} from '../../../../../admin/modules/admin-valet/services/admin-valet.service';
import {Mission} from '../../../models/mission';
import * as moment from 'moment';

@Component({
    selector: 'pv-common-mission-delayed-dialog',
    templateUrl: './common-mission-delayed-dialog.component.html',
    styleUrls: ['./common-mission-delayed-dialog.component.scss'],
    standalone: false
})
export class CommonMissionDelayedDialogComponent implements OnInit {

  public form: UntypedFormGroup;
  public types;
  public availableValetsData: any[] = [];
  public availableValets: any[] = [];
  public futurePrice: number;

  private subs: Subscription[] = [];

  @Input() mission: Mission;
  @Input() newDate: any;

  @Output() submitEvent = new EventEmitter();

  constructor(protected dialogRef: NbDialogRef<CommonMissionDelayedDialogComponent>,
              private commonMissionService: CommonMissionService,
              private fb: UntypedFormBuilder,
              private valetService: AdminValetService) { }

  ngOnInit(): void {
    this.subs.forEach(sub => sub.unsubscribe());

    this.form = this.fb.group({
      delayedReason: ['', Validators.required],
      valet: [null],
      note: [null],
      doNotSendDelayMail: false,
      applySurcharges: false
    });

    this.subs.push(this.form.get('delayedReason').valueChanges.subscribe(value => {
      if (value.startsWith('valet.')) {
        this.form.get('valet').setValue(this.mission.valetId?.id ?? null);
        this.form.get('valet').setValidators(Validators.required);
      } else {
        this.form.get('valet').setValue(null);
        this.form.get('valet').clearValidators();
      }
      this.form.get('valet').updateValueAndValidity();
    }));

    this.valetService.getActiveValets(false).then(valets => {
      this.availableValetsData = valets;
      this.availableValets = valets.map(valet => {
        return {
          name: valet.firstName + ' ' + valet.lastName,
          value: valet.id
        };
      });
    });

    this.types = this.commonMissionService.getMissionDelayedTypes();

    if (this.mission.status === 'in progress') {
      this.form.get('doNotSendDelayMail').setValue(true);
    }

    this.futurePrice = this.mission.price;
  }

  public showValetField() {
    return this.form.get('delayedReason').value.startsWith('valet.');
  }

  public showNewMissionPrice(checked: boolean) {
    if (checked) {
      const cleanDate = moment(this.newDate).tz('Europe/Paris').format('YYYY-MM-DD');
      this.commonMissionService.checkDelayedMissionPrice(cleanDate, this.mission.id).then(res => {
        this.futurePrice = res.delayedPrice;
      });
    }
  }

  submit() {
    this.submitEvent.emit(this.form.getRawValue());
  }
}
